"use strict";
exports.__esModule = true;
exports.TaskCardContainer = void 0;
var styled_1 = require("@hiyllo/ux/styled");
var react_native_1 = require("react-native");
exports.TaskCardContainer = (0, styled_1.styledRN)(react_native_1.Pressable, function (_a) {
    var $theme = _a.$theme, overdue = _a.overdue, isHighlighted = _a.isHighlighted, translucent = _a.translucent;
    return ({
        padding: overdue ? 8 : 10,
        borderWidth: overdue ? 2 : 0,
        borderColor: "#d3302f",
        borderStyle: "solid",
        borderRadius: 5,
        backgroundColor: isHighlighted === true ? $theme.midground : $theme.background3,
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 10,
        userSelect: "none",
        whiteSpace: "pre-wrap",
        color: $theme.foreground,
        opacity: translucent === true ? 0.3 : 1
    });
});
